export default __webpack_public_path__ + "static/media/mashoorah-logo-black.32e81185.svg";